"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAllRewards = void 0;
const react_1 = require("react");
const calculateClaimableAmounts_1 = require("./calculateClaimableAmounts");
const calculateRewardRates_1 = require("./calculateRewardRates");
const ONE_DAY_MS = 86400 * 1000;
const ONE_HOUR_MS = 3600 * 1000;
/**
 * Does some magical filtering to hide jumpyness. Prioritizing smoothness and
 * precision over accuracy
 *
 * @param getAmount Either getClaimableAmount or getTotalClaimableAmount
 * @returns
 */
const useAllRewards = ({ getAllClaimableAmounts, }) => {
    const rates = (0, react_1.useMemo)(() => {
        var _a, _b;
        return ((_b = (_a = (0, calculateRewardRates_1.calculateRewardRates)(getAllClaimableAmounts)) !== null && _a !== void 0 ? _a : (0, calculateRewardRates_1.calculateRewardRates)(getAllClaimableAmounts, ONE_DAY_MS)) !== null && _b !== void 0 ? _b : (0, calculateRewardRates_1.calculateRewardRates)(getAllClaimableAmounts, ONE_HOUR_MS));
    }, [getAllClaimableAmounts]);
    const amounts = (0, calculateClaimableAmounts_1.useGetPreciseClaimableAmounts)(rates);
    return {
        amounts,
        rates,
    };
};
exports.useAllRewards = useAllRewards;
//# sourceMappingURL=useRewards.js.map